import {Component, OnInit} from '@angular/core';
import {BundeslandFilterService} from '../../../service/bundeslandFilter/bundesland-filter.service';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {BundesLandName} from '../../../model/component/bundesland';

@Component({
  selector: 'app-sonstiges',
  templateUrl: './sonstiges.component.html',
  styleUrls: ['./sonstiges.component.css']
})
export class SonstigesComponent implements OnInit {

  selectedBundesland: string;
  selectedIndex = 0;

  constructor(public bundeslandFilterService: BundeslandFilterService) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
  }

  ngOnInit(): void {
  }


  onTabChange($event: MatTabChangeEvent) {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = 0;
  }

  isAvailableForBundesland() {
    return this.selectedBundesland === BundesLandName.BE || this.selectedBundesland === BundesLandName.BB;
  }
}
